import { Avatar, Grid, Typography } from 'antd';
import clsx from 'classnames';
import { FC } from 'react';

import { isDarkColor } from '../../utils';
import {
  useOrganization,
  useOrganizationSettings,
} from '../OrganizationProvider';

import styles from './styles.module.less';

const fallbackColor = '#0082ff';

type OrganizationHeaderProps = {
  collapsed?: boolean;
};

const OrganizationHeader: FC<OrganizationHeaderProps> = ({
  collapsed = false,
}) => {
  const screens = Grid.useBreakpoint();
  const { name } = useOrganization();
  const { brandmarkUrl, primaryColor } = useOrganizationSettings();
  const backgroundColor = primaryColor || fallbackColor;
  const color = isDarkColor(backgroundColor) ? '#fff' : 'rgba(0, 0, 0, 0.85)';

  return (
    <a href="/">
      <div
        className={clsx(styles.header, {
          [styles.collapsed]: collapsed,
        })}
      >
        {brandmarkUrl ? (
          <img alt={`${name} - Logo`} src={brandmarkUrl} width={32} />
        ) : (
          <Avatar
            className={styles.avatar}
            shape="square"
            size="large"
            style={{
              backgroundColor,
              color,
              verticalAlign: 'middle',
            }}
          >
            {name.charAt(0)}
          </Avatar>
        )}
        {(!collapsed || screens.xs) && (
          <div className={styles.container}>
            <Typography.Text className={styles.title}>{name}</Typography.Text>
            <Typography.Text className={styles.subtitle}>
              Partner Platform
            </Typography.Text>
          </div>
        )}
      </div>
    </a>
  );
};

OrganizationHeader.displayName = 'OrganizationHeader';

export default OrganizationHeader;
